<template>
  <el-dialog
    :title="$t('BAAlert.VideoTitle')"
    :visible.sync="dialogVisible"
    append-to-body
    @closed="handleClosed"
  >
    <div class="video-dialog-content">
      <video
        v-if="videoSrc"
        ref="alertVideoPlayer"
        class="video-player"
        :src="videoSrc"
        controls
        autoplay
        playsinline
      />
      <div v-else class="video-placeholder">
        {{ $t('BAAlert.NoVideoPath') }}
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    videoSrc: {
      type: String,
      default: ''
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  methods: {
    handleClosed () {
      const videoPlayer = this.$refs.alertVideoPlayer
      if (videoPlayer && typeof videoPlayer.pause === 'function') {
        videoPlayer.pause()
      }
      this.$emit('closed')
    }
  }
}
</script>

<style lang="scss" scoped>
.video-dialog-content {
  width: 100%;
  aspect-ratio: 16 / 9;
  min-height: 360px;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
}

.video-player {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

.video-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 16px;
}
</style>
